import * as React from 'react';
import cx from 'classnames';
import { GridFilled, ListDots } from '../Icons';
import { VIEW_OPTION } from '../types';

type ViewSwitchProps = {
  option?: VIEW_OPTION;
  onToggle?: (view: VIEW_OPTION) => void;
  className?: string;
};

export default function ViewSwitch({
  option = VIEW_OPTION.TILES,
  onToggle = () => {},
  className,
}: ViewSwitchProps) {
  const [selectedOption, setSelectedOption] = React.useState<
    VIEW_OPTION | undefined
  >(undefined);

  React.useEffect(() => {
    setSelectedOption(option);
  }, [option]);

  const isListSelected = selectedOption === VIEW_OPTION.LIST;

  const handleToggle = (view: VIEW_OPTION) => {
    setSelectedOption(view);
    onToggle(view);
  };

  return (
    <div className={cx('flex gap-2', className && className)}>
      <div
        onClick={() => handleToggle(VIEW_OPTION.TILES)}
        className={cx(
          'switch-btn',
          isListSelected ? 'bg-white' : 'bg-uta-black'
        )}
      >
        <GridFilled
          width={18}
          height={18}
          className={cx({ 'fill-white': !isListSelected })}
        />
      </div>
      <div
        onClick={() => handleToggle(VIEW_OPTION.LIST)}
        className={cx(
          'switch-btn',
          isListSelected ? 'bg-uta-black' : 'bg-white'
        )}
      >
        <ListDots
          width={18}
          height={18}
          className={cx({ 'fill-white': isListSelected })}
        />
      </div>
    </div>
  );
}
